import { Editor, Path, Transforms } from 'slate';
import EditorUtils from '../../../AhaEditorUtils/EditorUtils';
import { ReactEditor } from 'slate-react';
import type { EventHandlerParams } from './types';

const handleEnter = ({
  editor,
  event,
  currentBlock,
  isVoid,
}: EventHandlerParams) => {
  if (!isVoid) return;

  const targetPath = Path.next(currentBlock[1]);

  Transforms.insertNodes(editor, EditorUtils.emptyParagraph(), {
    at: targetPath,
  });
  Transforms.select(editor, Editor.point(editor, targetPath));

  event.preventDefault();
  ReactEditor.focus(editor);
  return true;
};

export default handleEnter;
